import _classCallCheck from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/batman/cabana/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { getMarkType } from '../mark';
import { isUnitSpec } from '../spec/unit';
export var CompositeMarkNormalizer =
/*#__PURE__*/
function () {
  function CompositeMarkNormalizer(name, run) {
    _classCallCheck(this, CompositeMarkNormalizer);

    this.name = name;
    this.run = run;
  }

  _createClass(CompositeMarkNormalizer, [{
    key: "hasMatchingType",
    value: function hasMatchingType(spec) {
      if (isUnitSpec(spec)) {
        return getMarkType(spec.mark) === this.name;
      }

      return false;
    }
  }]);

  return CompositeMarkNormalizer;
}();